
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/assembly-chunav/puducherry/results",
      function () {
        return require("private-next-pages/elections/assembly-chunav/puducherry/results/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/assembly-chunav/puducherry/results"])
      });
    }
  